import { lazy } from "react";

const PdfItemComponent = lazy(() => import("../Item/PdfItemComponent"));
const ShowSimilarProduct = lazy(() => import("../Item/ShowSimilarProduct"));
const GroupItem = lazy(() => import("../PartyGroup/GroupItem"));
const ItemPageScroll = lazy(() => import("../Item/ItemPageScroll"));
const SearchByImagePage = lazy(() => import("../SearchByImage/SearchByImagePage"));
const SearchByImageItemDetail = lazy(() => import("../SearchByImage/SearchByImageItemDetail"));
const PartyGroupItem = lazy(() => import("../PartyGroup/PartyGroupItem"));
const NewAdminCart = lazy(() => import("../Cart/NewAdminCart"));
const CustomerCart = lazy(() => import("../Cart/CustomerCart"));
const ResponsiveLogin = lazy(() => import("../Login/ResponsiveLogin"));
const Payment = lazy(() => import("../payment"));
const ResponsiveInquiry = lazy(() => import("../Enquiry/ResponsiveInquiry"));
const ResponsiveCatalogue = lazy(() =>
import("../MainPage/Catalogue/ResponsiveCatalogue")
);
const ResponsiveItemDetail = lazy(() => import("../Item/ResponsiveItemDetail"));
const ResposiveMainPage = lazy(() => import("../MainPage/ResposiveMainPage"));
const ResponsiveAddCatalogue = lazy(() =>
import("../AddCatalogue/ResponsiveAddCatalogue")
);
const ManageUsers = lazy(() => import("../ManageUsers/ManageUsers"));
const AllShowCatalogue = lazy(() => import("../AllShowCatalogue/AllShowCatalogue"));
const ManageEmployee = lazy(() => import("../ManageEmployee/ManageEmployee"));
const AttributeSetting = lazy(() =>
  import("../AttributeSetting/AttributeSetting")
);
const AddCatalogue = lazy(() => import("../ManageUsers/AddCatalogue"));
const QuotationList = lazy(() => import("../Quotation/QuotationList"));
const CreateQuotation = lazy(() => import("../Quotation/CreateQuotation"));

const Routes = [
  {
    path: "/Login",
    component: ResponsiveLogin,
  },
  {
    path: "/payment",
    component: Payment,
  },
  {
    path: "/Main",
    component: ResposiveMainPage,
    routes: [
      {
        path: "/Main/Catalogues",
        component: ResponsiveCatalogue,
      },
      {
        path: "/Main/CataloguesItem",
        component: ItemPageScroll,
      },
      {
        path: "/Main/SearchByImage/Detail/:id",
        component: SearchByImageItemDetail,
      },
      {
        path: "/Main/SearchByImage",
        component: SearchByImagePage,
      },
      {
        path: "/Main/CatalogueDetails/Similar-Product",
        component: ShowSimilarProduct,
      },
      {
        path: "/Main/PdfCataloguesItem",
        component: PdfItemComponent,
      },
      {
        path: "/Main/CatalogueDetail/:id",
        component: ResponsiveItemDetail,
      },
      {
        path: "/Main/CataloguesFilterGroup",
        component: PartyGroupItem,
      },
      {
        path: "/Main/CataloguesFilterGroupItems",
        component: GroupItem,
      },
      {
        path: "/Main/Enquiry",
        component: ResponsiveInquiry,
      },
      {
        path: "/Main/AddCatalogues",
        component: ResponsiveAddCatalogue,
      },
      {
        path: "/Main/ManageUsers",
        component: ManageUsers,
      },
      {
        path: "/Main/ManageEmployee",
        component: ManageEmployee,
      },
      {
        path: "/Main/Cart",
        component: CustomerCart,
      },
      {
        path: "/Main/AdminCart",
        component: NewAdminCart,
      },
      {
        path: "/Main/AttributeSettings",
        component: AttributeSetting,
      },
      {
        path: "/Main/AddCatalogue/:id",
        component: AddCatalogue,
      },
      {
        path: "/Main/QuotationList",
        component: QuotationList,
      },
      {
        path: "/Main/CreateQuotation",
        component: CreateQuotation,
      },
      {
        path: "/Main/AllShowCatalogue",
        component: AllShowCatalogue,
      },
    ],
  },
];

export default Routes;

/*
  // const AdminCart = lazy(() => import('../Cart/AdminCart'));
// const AdminItemPageScroll = lazy(() => import('../Item/AdminItemPageScroll'));
  {
                path: '/Main/EnquiryItems',
                component: EnquiryItem
            },
  */

// const MainPage = lazy(() => import('../MainPage/MainPage'));
// const ItemDetail = lazy(() => import("../Item/ItemDetail"));
// const Catalogue = lazy(() => import("../MainPage/Catalogue/Catalogue"));
// const Cart  = lazy(() => import("../Cart/Cart"));
// const Enquiry = lazy(() => import("../Enquiry/Enquiry"));
// const EnquiryItem = lazy(() => import("../Enquiry/EnquiryItem"));
// const AddCatalogue =  lazy(() => import("../AddCatalogue/AddCatalogue"));
// path: '/Main/Cart',
// component: ResponsiveCart // import Login from "../Login/Login"
// const ResponsiveCart = lazy(() => import('../Cart/ResponsiveCart'));
